"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BonusTournamentBotsEditor_1 = require("./BonusTournamentBotsEditor");
var BonusTournamentBotsList_1 = require("./BonusTournamentBotsList");
var BonusTournamentBots = /** @class */ (function (_super) {
    __extends(BonusTournamentBots, _super);
    function BonusTournamentBots(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentBots.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_BA = this.props.listPlayersAvail.Subscribe("*", function (id, data) {
            _this.setState({ availBots: data.data });
        });
        this.SID_JT = this.props.listBotJoinTypes.Subscribe("*", function (id, data) {
            _this.setState({ availJoins: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availBots: [],
            availJoins: []
        }, function () {
            _this.props.listPlayersAvail.LoadDataBots(_this.props.record.brand_id, "");
            _this.props.listBotJoinTypes.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Турниры", "Боты турнира"]);
    };
    BonusTournamentBots.prototype.componentWillUnmount = function () {
        this.props.listPlayersAvail.UnSubscribe(this.SID_BA);
        this.props.listBotJoinTypes.UnSubscribe(this.SID_JT);
    };
    BonusTournamentBots.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BonusTournamentBots.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    BonusTournamentBots.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    BonusTournamentBots.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    BonusTournamentBots.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTournamentBotsEditor_1.default, { state: this.props.state, data: this.props.dataBots, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availBots: this.state.availBots, availJoinTypes: this.state.availJoins, record: null, listTournamentGamesAvail: this.props.listTournamentGamesAvail }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTournamentBotsEditor_1.default, { state: this.props.state, data: this.props.dataBots, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availBots: this.state.availBots, availJoinTypes: this.state.availJoins, record: this.state.record, listTournamentGamesAvail: this.props.listTournamentGamesAvail }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTournamentBotsList_1.default, { state: this.props.state, data: this.props.dataBots, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    BonusTournamentBots.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return BonusTournamentBots;
}(React.Component));
exports.default = BonusTournamentBots;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/bots/BonusTournamentBots.tsx
// module id = 2522
// module chunks = 0